import { render, staticRenderFns } from "./omzet-domestik.vue?vue&type=template&id=74712ab9&scoped=true&"
import script from "./omzet-domestik.vue?vue&type=script&lang=js&"
export * from "./omzet-domestik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74712ab9",
  null
  
)

export default component.exports